export class ErrorClass {
    constructor(
        public err: string,
        public errCode: number,
        public errDesc: string,
        public errType: string
    ) { }
}


// WEBPACK FOOTER //
// ./src/app/error/error-class.ts